import React from 'react';
import facebookIcon from 'assets/images/social/facebook-icon-ft.png';
import linkedinIcon from 'assets/images/social/linked-icon-ft.png';
import instagramIcon from 'assets/images/social/instagram-icon-ft.png';
const Copyright = () => {
    const year = new Date().getFullYear();
    return (React.createElement("div", { className: "copyright-bx" },
        React.createElement("p", null,
            "Copyright ",
            year,
            " \u00B7 All rights reserved - Get updates:"),
        React.createElement("ul", { className: "footer-social-icon" },
            React.createElement("li", null,
                React.createElement("a", { href: "https://www.facebook.com/pages/Attorneys-in-Motion/142426379301888", target: "_blank", rel: "noreferrer noopener" },
                    React.createElement("img", { src: facebookIcon, alt: "Follow Attorneys in Motion on Facebook", title: "Follow Attorneys in Motion on Facebook" }))),
            React.createElement("li", null,
                React.createElement("a", { href: "https://www.instagram.com/attorneysinmotion", target: "_blank", rel: "noreferrer noopener" },
                    React.createElement("img", { src: instagramIcon, alt: "Follow Attorneys in Motion on Instagram", title: "Follow Attorneys in Motion on Instagram" }))),
            React.createElement("li", null,
                React.createElement("a", { href: "https://www.linkedin.com/company/attorneys-in-motion", target: "_blank", rel: "noreferrer noopener" },
                    React.createElement("img", { src: linkedinIcon, alt: "Follow Attorneys in Motion on LinkedIn", title: "Follow Attorneys in Motion on LinkedIn" }))))));
};
export default Copyright;
